import {BREAK_POINTS} from '../settings';

export default function() {
  let saveTop = 0;
  let isShowingTarget = false;
  $('.js-gnav').on('click', function(e) {
    e.preventDefault();

    if( $('.js-gnav-target').css('display') == 'none' ) {
      isShowingTarget = false;
      saveTop = $(window).scrollTop();
    } else {
      isShowingTarget = true;
    }

    $('.js-gnav').toggleClass('is-active');
    $('body').toggleClass('c-show-modal');

    if( !isShowingTarget ) {
      // $('.js-gnav-target').scrollTop(0)
      $('.js-gnav-target').fadeIn();
      $(this).trigger('showGnav');
    } else {
      $('.js-gnav-target').fadeOut(function() {
        // $(window).scrollTop(saveTop);
      });
      $(this).trigger('hideGnav');
    }

  });
}
